import { render, staticRenderFns } from "./TransactionInformation.vue?vue&type=template&id=40475f3d"
import script from "./TransactionInformation.vue?vue&type=script&lang=js"
export * from "./TransactionInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports